import React from 'react';
import { EyeIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';

interface ReadOnlyBadgeProps {
  className?: string;
  showIcon?: boolean;
  text?: string;
}

/**
 * Badge that appears for viewers to indicate read-only access.
 * Only shows if user has viewer role.
 *
 * Usage:
 *   <ReadOnlyBadge />
 *   <ReadOnlyBadge text="View Only" />
 *   <ReadOnlyBadge showIcon={false} />
 */
export const ReadOnlyBadge: React.FC<ReadOnlyBadgeProps> = ({
  className = '',
  showIcon = true,
  text = 'Read-Only Access'
}) => {
  const { isViewer } = useAuth();

  if (!isViewer()) {
    return null;
  }

  return (
    <span className={`inline-flex items-center px-3 py-1.5 border border-yellow-200 bg-yellow-50 rounded-md text-sm text-yellow-800 ${className}`}>
      {showIcon && <EyeIcon className="h-4 w-4 mr-2" />}
      {text}
    </span>
  );
};

export default ReadOnlyBadge;
